export const DoctorFeeMenuIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_961_35831)">
      <path
        d="M7.85152 3.46241C10.2487 1.06415 14.1365 1.06507 16.5346 3.46241C18.9327 5.85975 18.9327 9.74791 16.5346 12.1462M13.9476 12.1897C13.9476 15.5813 11.1984 18.3307 7.80707 18.3307C4.41573 18.3307 1.6665 15.5813 1.6665 12.1897C1.6665 8.79809 4.41573 6.04865 7.80707 6.04865C11.1984 6.04865 13.9476 8.79809 13.9476 12.1897Z"
        stroke={props?.color || '#101828'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_961_35831">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
